import $ from "jquery"

function tripMsg(key, fallback) {
  return (window.TRIP_VALIDATION_MESSAGES && window.TRIP_VALIDATION_MESSAGES[key]) || fallback;
}

function errKey($el) {
  return $el.attr('id') || $el.prop('tagName').toLowerCase();
}

function showTripError($el, msg) {
  var key = errKey($el);
  $el.addClass('is-invalid');
  var $ig = $el.closest('.input-group');
  if ($ig.length) $ig.addClass('input-group-invalid');
  $('[data-ferr="' + key + '"]').remove();
  var $after = $ig.length ? $ig : $el;
  $after.after(
    '<small class="field-error text-danger d-flex align-items-center mt-1" data-ferr="' + key + '">' +
    '<span class="mr-1">&#9888;</span>' + msg + '</small>'
  );
}

function clearTripError($el) {
  $el.removeClass('is-invalid');
  $el.closest('.input-group').removeClass('input-group-invalid');
  $('[data-ferr="' + errKey($el) + '"]').remove();
}

window.initTripFormValidation = function() {
  var TRIP_FIELDS = [
    ['#trip_bag_closing_date',       tripMsg('bag_closing_date', 'Bag closing date is required')],
    ['#trip_departure_date',         tripMsg('departure_date', 'Departure date is required')],
    ['#trip_arrival_date',           tripMsg('arrival_date', 'Arrival date is required')],
    ['#trip_price_per_kg',           tripMsg('price_per_kg', 'Price per kg is required')],
    ['#trip_total_available_weight', tripMsg('available_weight', 'Available weight is required')]
  ];

  var TRIP_CITIES = [
    ['#trip_from_city_id', tripMsg('departure_city', 'Departure city is required')],
    ['#trip_to_city_id',   tripMsg('arrival_city', 'Arrival city is required')]
  ];

  // Remove previous capture handler before re-registering
  if (window._tripFormSubmitCapture) {
    document.removeEventListener('submit', window._tripFormSubmitCapture, true);
  }

  // Capture phase runs before Rails UJS bubble-phase handler.
  // On failure: preventDefault + stopPropagation → Rails UJS never sees the event → button stays enabled.
  // On success: event propagates normally → Rails UJS disables button → form submits.
  window._tripFormSubmitCapture = function(e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('trip-form')) return;

    var valid = true, $first = null;

    TRIP_FIELDS.forEach(function(f) {
      var $el = $(f[0]);
      if (!$el.length || $el.prop('disabled')) return;
      var val = ($el.val() || '').trim();
      if (!val) {
        var picker = $el.data('DateTimePicker');
        if (picker && picker.date() && picker.date().isValid && picker.date().isValid()) {
          val = 'selected';
        }
      }
      if (val) {
        clearTripError($el);
      } else {
        showTripError($el, f[1]);
        if (!$first) $first = $el;
        valid = false;
      }
    });

    TRIP_CITIES.forEach(function(f) {
      var $sel = $(f[0]);
      var $s2  = $sel.next('.select2-container');
      var key  = errKey($sel);
      if (!$sel.val()) {
        $('[data-ferr="' + key + '"]').remove();
        $s2.after(
          '<small class="field-error text-danger align-items-center mt-1" data-ferr="' + key + '">' +
          '<span class="mr-1">&#9888;</span>' + f[1] + '</small>'
        );
        if (!$first) $first = $s2;
        valid = false;
      } else {
        $('[data-ferr="' + key + '"]').remove();
      }
    });

    var $trix = $('trix-editor').first();
    if ($trix.length) {
      if (($trix[0].innerText || '').trim()) {
        clearTripError($trix);
      } else {
        showTripError($trix, tripMsg('trip_details', 'Trip details are required'));
        if (!$first) $first = $trix;
        valid = false;
      }
    }

    var $rulesInputs = $('input[name="trip[rule_template_ids][]"]');
    if ($rulesInputs.length) {
      var $rulesCard = $rulesInputs.closest('.card');
      if ($rulesInputs.filter(':checked').length === 0) {
        if (!$rulesCard.find('.rules-error').length) {
          $rulesCard.find('.card-body').append(
            '<small class="rules-error text-danger mt-2 d-block">' + tripMsg('trip_rules', 'Please select at least one trip rule') + '</small>'
          );
        }
        if (!$first) $first = $rulesCard;
        valid = false;
      } else {
        $rulesCard.find('.rules-error').remove();
      }
    }

    if (!valid) {
      e.preventDefault();
      e.stopPropagation();
      if ($first) $('html, body').animate({ scrollTop: $first.offset().top - 120 }, 300);
    }
  };

  document.addEventListener('submit', window._tripFormSubmitCapture, true);

  // Clear errors on user interaction
  $(document)
    .off('input.tripValidate change.tripValidate dp.change.tripValidate', TRIP_FIELDS.map(function(f) { return f[0]; }).join(','))
    .on('input.tripValidate change.tripValidate dp.change.tripValidate', TRIP_FIELDS.map(function(f) { return f[0]; }).join(','), function() {
      clearTripError($(this));
    });

  $(document)
    .off('change.tripValidate', TRIP_CITIES.map(function(f) { return f[0]; }).join(','))
    .on('change.tripValidate', TRIP_CITIES.map(function(f) { return f[0]; }).join(','), function() {
      $('[data-ferr="' + errKey($(this)) + '"]').remove();
    });

  $(document)
    .off('trix-change.tripValidate', 'trix-editor')
    .on('trix-change.tripValidate', 'trix-editor', function() {
      clearTripError($(this));
    });

  $(document)
    .off('change.tripValidate', 'input[name="trip[rule_template_ids][]"]')
    .on('change.tripValidate', 'input[name="trip[rule_template_ids][]"]', function() {
      if ($('input[name="trip[rule_template_ids][]"]:checked').length > 0) {
        $('input[name="trip[rule_template_ids][]"]').closest('.card').find('.rules-error').remove();
      }
    });
};

$(document).on('turbolinks:load', function() {
  if ($('.trip-form').length) {
    window.initTripFormValidation();
  }
});
